import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

interface ISearchSection {
  searchedValue: string;
  handleClearSearch: () => void;
}

export const SearchSection: FC<ISearchSection> = ({ searchedValue, handleClearSearch }) => {
  return (
    <Box marginBottom="1rem" display="flex" alignItems="center" flexWrap="wrap">
      <Typography color="secondary">Showing results for "{searchedValue}"</Typography>
      <Box marginLeft="5px">
        <Button id="clear-search" size="small" color="inherit" startIcon={<Close />} onClick={handleClearSearch} sx={{ lineHeight: 1 }}>
          Clear Search
        </Button>
      </Box>
    </Box>
  );
};
